import React from 'react';
import "./CommonTable.scss";
import { Table } from 'react-bootstrap';
import PerfectScrollbar from "react-perfect-scrollbar";

const CommonTable = ({ className, children }) => {
    return (
        <>
            <div className={`common_table ${className}`}>
                <PerfectScrollbar>
                    <Table responsive>
                        {children}
                    </Table>
                </PerfectScrollbar>
            </div>
        </>
    );
};

export default CommonTable;